import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

// Props for styles that require external inputs
interface ErrorStyleProps {
  height: string | number;
  width: string | number;
}

interface RootStyleProps extends ErrorStyleProps {
  isMobile?: boolean;
}

export const useErrorStyles = makeStyles<Theme, ErrorStyleProps>((theme) => ({
  root: ({ height, width }) => ({
    borderRadius: "4px",
    border: `1px solid ${theme.palette.primary.main}`,
    height,
    width,
  }),
}));

const useStyles = makeStyles<Theme, RootStyleProps>(() => ({
  root: ({ height, width, isMobile }) => ({
    borderRadius: "4px",
    border: "1px solid #E3E5E5",
    padding: isMobile ? "16px" : "36px",
    // You had a small syntax issue here — this is fixed using a template literal
    height: `calc(${height} - 2 * 36px)`,
    width,
  }),
  periodTitle: {
    color: "#5E6366",
    fontFamily: "Mulish",
    fontSize: "16px",
    lineHeight: "25px",
    letterSpacing: "0.44px",
  },
  period: {
    fontFamily: "Mulish",
    fontSize: "34px",
    letterSpacing: "0.25px",
    color: "#5E6366",
    lineHeight: "42px",
  },
  divider: {
    padding: "16px 8px 0px 8px",
    borderBottom: "1px solid #E3E5E5",
    marginBottom: "32px",
  },
  skeleton: {
    marginTop: "-8px",
  },
}));

export default useStyles;
